<div class="apply-for-beta">
  <a routerLink="/signup" class="apply-for-beta__link">Join the Waitlist</a>
</div>
